/**
 * Container, to replace the logic in Container.js.
 * Is used for the parse/toJson ability.
 *
 * TODO: Replace all modal logic in Container.js with this.
 */

var VRC = VRC || {};

VRC.Container = (function(data){
  var _colour;
  var _deckId;
  var _destination;
  var _dgClass;
  var _dgInfo;
  var _cargoDgInfo;
  var _divId;

  var _length;
  var _rotation;
  var _weight;
  var _width;
  var _id;
  var _image;
  var _origin;
  var _position = {
    x : 0,
    y : 0
  };
  var _prevId;
  var _properties = {
    dangerous : false,
    priority : false,
    roundtrip : false,
    storage : false,
    transfer : false
  };
  var _remarks = '';
  var _tag;
  var _type;
  var _dgClasses;

  var getColour = function () {
    return _colour;
  };

  var setColour = function (colour) {
    if(!colour) {
      colour = SetContainerColour({origin: getOrigin(), destination: getDestination()})
    }
    _colour = colour;
  };

  var getDestination = function () {
    return _destination;
  };

  var getDestinationName = function(){
    var destination =  VRC.MasterDataService.getPort(getDestination());

     return destination ? destination.name  : '';
  };

  var setDestination = function (destination) {
    _destination = VRC.Utils.Number.parseInt(destination);
  };

  var getDeckId = function () {
    return _deckId;
  };

  var setDeckId = function (deckId) {
    if(deckId === undefined){
      deckId = 'transit_area';
    }
    _deckId = deckId;
  };

  var getDgClass = function () {
    return _dgClass;
  };

  var setDgClass = function (dgClass) {
    if(_.isArray(dgClass)){
      dgClass = dgClass.join(',');
    }
    _dgClass = VRC.Utils.String.validateDgClasses(dgClass);
  };

  var getDgInfo = function () {
    return _dgInfo;
  };

  var setDgInfo = function (dgInfo) {

    _dgInfo = dgInfo;
  };

  var getCargoDgInfo = function () {
    return _cargoDgInfo;
  };

  var setCargoDgInfo = function (cargoDgInfo) {

    _cargoDgInfo = cargoDgInfo;
  };

  var getDivId = function () {
    return '#'+getId();
  };



  var getFeatures = function () {
    return {
      length : getLength(),
      width : getWidth(),
      weight : getWeight(),
      rotation : getRotation()
    };
  };


  var getLength = function () {
    return _length;
  };

  var setLength = function (length) {
    _length = VRC.Utils.Number.parseFloat(length) || 1;
  };

  var getRotation = function () {
    return _rotation;
  };

  var setRotation = function (rotation) {
    _rotation =  VRC.Utils.Number.parseInt(rotation) || 0;
  };

  var getWeight = function () {
    return _weight;
  };

  var setWeight = function (weight) {
    _weight = VRC.Utils.Number.parseFloat(weight);
  };

  var getWidth = function () {
    return _width;
  };

  var setWidth = function (width) {
    _width = VRC.Utils.Number.parseFloat(width) || 1;
  };

  var getId = function () {
    return _id;
  };

  var setId = function (id) {
     if(!id){
       var date = new Date();
       id = 'container_' + Math.floor( Math.random()* 1000 ) + '_' + date.getTime();
     }
    _id = id;
  };

  var getImage = function () {
    return _image;
  };

  var setImage = function (image) {
    if(!image){
      image = undefined;
    }
    _image = image;
  };

  var getOrigin = function () {
    return _origin;
  };

  var getOriginName = function(){
    var origin = VRC.MasterDataService.getPort(getOrigin());
    return origin ? origin.name : '';
  };

  var setOrigin = function (origin) {

    _origin = VRC.Utils.Number.parseInt(origin);

  };

  var getPosition = function () {
    return _position;
  };

  var setPosition = function (position) {
    position = position || {};
    setPosX(position.x);
    setPosY(position.y);
  };

  var getPosX = function () {
    return _position.x;
  };

  var setPosX = function (x){

    _position.x = VRC.Utils.Number.parseFloat(x) || 0 ;
  };

  var getPosY = function () {
    return _position.y;
  };

  var setPosY = function (y) {
    _position.y = VRC.Utils.Number.parseFloat(y) || 0 ;
  };

  var getPrevId = function () {
    return _prevId;
  };

  var setPrevId = function (prevId) {
    _prevId = prevId;
  };

  var getProperties = function () {
    return _properties;
  };

  var setProperties = function (properties) {
    if(properties){
      _.each(properties, function(value, type){
        setProperty(type, value);
      });
    }
  };


  var setProperty = function(type, value){
    value = !!(value === true || value === 'true' || value === 1 || value === '1' || value === 'on');
    _properties[type] = value;
  };

  var getRemarks = function () {
    return _remarks;
  };

  var setRemarks = function (remarks) {
    _remarks = remarks;
  };

  var getTag = function () {
    return _tag;
  };

  var setTag = function (tag) {
    _tag = tag;
  };

  var getType = function () {
    return _type;
  };

  var setType = function (type) {
    _type = type;
  };


  var parse = function(obj){
    obj = obj || {};
    obj.features = obj.features || {};
    obj.position =  obj.position || {};
    obj.properties =  obj.properties ||  {};


    setDeckId(obj.deckID);
    setDestination(obj.destination);
    setDgClass(obj.dg_class);
    setDgInfo(obj.dg_info);
    setCargoDgInfo(obj.cargo_dg_info);
    setWeight(obj.features.weight);
    setWidth(obj.features.width);
    setLength(obj.features.length);
    setRotation(obj.features.rotation);
    setWeight(obj.features.weight);
    setId(obj.id);
    setImage(obj.image);
    setOrigin(obj.origin);
    setPosX(obj.position.x);
    setPosY(obj.position.y);
    setPrevId(obj.prev_id);
    setProperties(obj.properties);
    setRemarks(obj.remarks);
    setTag(obj.tag);
    setType(obj.type);
    setColour(obj.colour);

  };



  var toJson = function(){
    var json = {
      colour : getColour(),
      deckID: getDeckId(),
      destination: getDestination(),
      destinationName : getDestinationName(),
      dg_class: getDgClass(),
      dg_info: getDgInfo(),
      cargo_dg_info: getCargoDgInfo(),
      divID: getDivId(),
      features: getFeatures(),
      id: getId(),
      image: getImage(),
      origin: getOrigin(),
      originName : getOriginName(),
      position: getPosition(),
      prev_id: getPrevId(),
      properties: getProperties(),
      remarks: getRemarks(),
      tag: getTag(),
      type: getType()
    };

    return json;

  };



  var update = function(data){

    parse($.extend(toJson(),data));
  };

  var init = function(data){
    if(data){
      parse(data);
    }

  };

  init(data);
  return {
    parse : parse,
    update : update,
    toJson : toJson,
    setDeckId : setDeckId,
    setPosX : setPosX,
    setPosY : setPosY,
    setOrigin: setOrigin,
    setDestination: setDestination,
    setType : setType,
    getRotation : getRotation
  }
});
